/**
 * PLAT-11650 — the red-line palette the transcript already speaks: removed
 * text is struck through in `indianred` (`TranscriptionText.tsx` `.state-removed`,
 * `TranscriptionDiffTranslated.tsx`), added text reads in the redline green
 * (`.state-added-with-diff`, `_TranscriptionDiff.tsx`). Named here so a new
 * surface that shows a diff borrows these rather than inventing a palette —
 * and never gold, which is the playhead / creative-control colour.
 */
export const REDLINE_REMOVED_COLOR = 'indianred';
export const REDLINE_ADDED_COLOR = '#7bb975';
